<template>
  <div class="login">
    <div class="login-context">
      <div class="login-context-left">
        <el-image style="height: 100%" :src="welcomeBg" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        <div class="mask"></div>
        <div class="welcome-text">
          <p class="welcome-text-title">Welcome!</p>
          <p>Yimeng Management System</p>
        </div>
      </div>
<!--      <div class="login-context-text">-->
<!--        <p>Hi，你好！</p>-->
<!--        <p>欢迎进入以萌后台管理系统</p>-->
<!--        <p class="tip">Welcome To Yimeng Management System</p>-->
<!--      </div>-->
      <div class="login-context-right">
        <div class="login-title">
          <p>以萌后台管理系统</p>
          <p class="login-tip">Management System</p>
        </div>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
        >
          <el-form-item prop="account">
            <el-input v-model="ruleForm.account" size="large" placeholder="请输入账号" clearable @keyup.enter.native="login($event)">
              <template #prefix>
                <el-icon class="el-input__icon"><ElIcons name="User" /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <el-input v-model="ruleForm.pwd" size="large" type="password" placeholder="请输入密码" show-password @keyup.enter.native="login($event)">
              <template #prefix>
                <el-icon class="el-input__icon"><ElIcons name="Lock" /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
              <el-input v-model="ruleForm.code" size="large"  placeholder="验证码"  @keyup.enter.native="login($event)" style="width: 100%">
                <template #prefix>
                  <el-icon class="el-input__icon"><ElIcons name="CollectionTag" /></el-icon>
                </template>
              </el-input>
              <el-image style="height: 40px; min-width: 76px; margin-left: 8px; cursor: pointer;" :src="captchaImg" @click="getCaptchaInfo"/>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="large" style="width: 100%; margin-top: 12px;" @click.native.prevent="login()" v-loading="logining">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
import { reactive } from 'vue'
import {getFormData, postFormData} from '../../api/api'
import {loginUrl, menuList, getCaptcha} from '../../api/url'

export default {
  name: "login",
  data() {
    return {
      welcomeBg: require('../../assets/image/welcome.jpg'),
      logining: false,
      loginParam: new Object(),
      uuid: '',
      captchaImg: '',
      ruleForm: reactive({
        account: '',
        pwd: '',
      }),
      rules: reactive({
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
      }),
    }
  },
  methods: {
    login() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.logining = true;
          this.loginParam.account = this.ruleForm.account;
          this.loginParam.pwd = this.ruleForm.pwd;
          this.loginParam.uuid = this.uuid;
          this.loginParam.code = this.ruleForm.code;
          postFormData(loginUrl, this.loginParam).then((data) => {
            this.logining = false;
            let {msg,code} = data;
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              sessionStorage.setItem('account', JSON.stringify(this.ruleForm.account));
              sessionStorage.setItem('ownShopList', JSON.stringify(data.data.ownShopList));
              // sessionStorage.setItem('visibleShopList', JSON.stringify(data.data.visibleShopList));
              sessionStorage.setItem('positionType', JSON.stringify(data.data.positionType));
              sessionStorage.setItem('accountId', JSON.stringify(data.data.id));
              sessionStorage.setItem('isSuper', JSON.stringify(data.data.isSuper));
              sessionStorage.setItem('operateState', JSON.stringify(data.data.operateState));
              this.getMenuList(data.data.sysMenuList)
            } else {
              this.logining = false;
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'error'
              });
              this.getCaptchaInfo()
            }
          }).catch((err) => {
            this.$message({
              showClose: true,
              duration: 1000,
              message: err.msg,
              type: 'error'
            });
            this.logining = false;
          })
        } else {
          return false;
        }
      });
    },

    //导航菜单
    getMenuList(list) {
      let sysList = list
      this.menuList = this.formatList(sysList, 0)
      localStorage.setItem('menuList', JSON.stringify(this.menuList))
      localStorage.setItem('menuLockList', JSON.stringify(this.menuList))
      let navArray = []
      sysList.map((item)=>{
        if(item.url) {
          navArray.push(item.url)
        }
      })
      sessionStorage.setItem('navArray', JSON.stringify(navArray))
      this.$router.push({
        path: '/home'
      });
    },
    /**
     * 格式化权限
     */
    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      // console.log(array)
      return array;
    },

    getCaptchaInfo() {
      getFormData(getCaptcha).then(data => {
        this.uuid = data.data.uuid
        // this.captchaImg = data.data.captchaImg
        this.captchaImg='data:image/png;base64,' + data.data.captchaImg
      })
    },


  },
  mounted() {
    this.getCaptchaInfo()
  }
}
</script>

<style scoped>
.login {
  /*background-image: url("../../assets/image/loginBg.png");*/
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  background-color: #011223;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}
.login-context{
  /*background-color: #ffffff;*/
  display: flex;
  z-index: 999;
  /*width: 1000px;*/
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*align-items: center;*/
}
.login-context-left {
  width: 300px;
  position: relative;
}
.login-context-text {
  font-size: 40px;
  font-weight: bolder;
  color: #ffffff;
  text-align: left;
  /*margin-top: 24px;*/
}
.login-context-text .tip {
  font-size: 14px;
  font-weight: normal;
  margin-top: 8px;
}
.login-context-right {
  background-color: #ffffff;
  width: 300px;
  padding: 64px;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.1);
}
.welcome-text{
  /*letter-spacing: 1px;*/
  color: #ffffff;
  font-size: 12px;
  position: absolute;
  bottom: 48px;
  left: 28px;
  text-align: left;
}
.welcome-text-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}
/*.welcome-text-title::after {*/
/*  display: block;*/
/*  content: '';*/
/*  width: 38px;*/
/*  height: 1px;*/
/*  background-color: #ffffff;*/
/*  margin-top: 2px;*/
/*}*/
.login-title {
  /*font-family: "微软雅黑", Arial, sans-serif;*/
  color: #222222;
  font-size: 26px;
  font-weight: bold;
  /*margin-bottom: 16px;*/
  letter-spacing: 1px;
  margin-bottom: 40px;
}
.login-tip {
  font-size: 14px;
  font-weight: normal;
  /*text-transform:uppercase;*/
  letter-spacing: 1px;
  color: #bbbbbb;
}
</style>
